const Discover = (target) => {
  const initDiscover = el => {
    if (!el.dataset.modalText) return false
    el.addEventListener('click', e => {
      const target = e.currentTarget
      const text = target.dataset.modalText
      // eslint-disable-next-line no-undef
      swal.fire({
        text,
        showCloseButton: true,
        closeButtonHtml: '<i class="icon icon-close"></i>',
        showConfirmButton: false,
      })
    })
  };

  $('body').find(target)
    .each((_, el) => {
      initDiscover(el);
    });
}

export default Discover;



// WEBPACK FOOTER //
// ./scripts/components/Discover.js